var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c(_vm.mapType,_vm._g({tag:"component",attrs:{"alarm":_vm.alarm,"units":_vm.units,"unit_id":_vm.unit_id,"data":_vm.data,"tabInfo":_vm.tabInfo,"isCard":_vm.isCard}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }